// 2026-11-05: feature flags (api/src/flags.ts; Admin > Features turns each off | just me | everyone). GET /api/me
// carries this user's `flags` ({key: boolean}); these read the loaded payload. An unknown key, or no payload yet, is off.
//   useFlag("hands_on_board")  in a component (re-renders when /api/me reloads)
//   flagOn("hands_on_board")   anywhere else (a plain read, no subscription)
import { get, useStore } from "./store";

/** Pure: a flag in a flags map (missing = off). */
export const flagIn = (flags: Record<string, boolean> | null | undefined, key: string): boolean => flags?.[key] === true;

/** A plain read of the loaded /api/me flags. */
export function flagOn(key: string): boolean {
  return flagIn(get().me?.flags, key);
}

/** The React hook: true when the flag is on for this user. */
export function useFlag(key: string): boolean {
  return useStore((s) => flagIn(s.me?.flags, key));
}
